import {AnyAction} from 'redux';
import {HIDE_IN_APP_VIDEOS, SHOW_IN_APP_VIDEOS} from '@app/store/constants';

const initialState = {
    isInAppVideosModalOpened: false
};

export function inAppVideos(state = initialState, action: AnyAction) {
    const { type } = action;

    switch (type) {
        case SHOW_IN_APP_VIDEOS:
            return {
                ...state,
                isInAppVideosModalOpened: true
            };

        case HIDE_IN_APP_VIDEOS:
            return {
                ...state,
                isInAppVideosModalOpened: false
            };

        default:
            return state;
    }
}
